const actions = {
  ASSIGNED_USER_TOPICS_BEGIN: 'ASSIGNED_USER_TOPICS_BEGIN',
  ASSIGNED_USER_TOPICS_SUCCESS: 'ASSIGNED_USER_TOPICS_SUCCESS',
  ASSIGNED_USER_TOPICS_ERR: 'ASSIGNED_USER_TOPICS_ERR',

  assignedUserTopicsBegin: () => {
    return {
      type:  actions.ASSIGNED_USER_TOPICS_BEGIN
    };
  },

  assignedUserTopicsSuccess: data => {
    return {
      type: actions.ASSIGNED_USER_TOPICS_SUCCESS,
      data,
    };
  },

  assignedUserTopicsErr: err => {
    return {
      type:  actions.ASSIGNED_USER_TOPICS_ERR,
      err,
    };
  },
};

export default actions;